import { createTypeElement, createPropTypes } from './util'

const Tip = props => createTypeElement('Tip', props)
Tip.propTypes = createPropTypes()
Tip.defaultProps = {
  as: 'span',
}
export default Tip
